"use client";
import {
  arrowImageTransition,
  formStagger,
  formStaggerChildrenRight,
  formStaggerChildrenUp,
} from "@/commonComponents/animations";
import ArrowImage from "@/commonComponents/arrow-image";
import BorderedIconButton, {
  iconButtonLargeSx,
} from "@/commonComponents/bordered-icon-button";
import {
  MotionListItem,
  MotionStack,
} from "@/commonComponents/motion-components";
import SectionWrapper from "@/commonComponents/section-wrapper";
import { FileDownloadOutlined } from "@mui/icons-material";
import { ListItemText, Stack, Typography } from "@mui/material";
import { StaticImageData } from "next/image";
import Link from "@cc/link";
import React from "react";

export interface NewsAndMediaPressKitProps {
  arrowImage: StaticImageData | string;
  header: string;
  subHeader: string;
  caption?: string;
  href?: string;
  downloadData?: {
    title: string;
    subTitle: string;
    href: string;
  }[];
  navId?: string;
}

const NewsAndMediaPressKit = (props: NewsAndMediaPressKitProps) => {
  const { arrowImage, header, subHeader, caption, href, downloadData, navId } =
    props;
  return (
    <SectionWrapper
      SectionProps={{
        sx: {
          background: (theme) => theme.palette.gradient.lightToDark,
        },
      }}
      navId={navId || "Press-kit"}
    >
      <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        rowGap={5}
        columnGap={5}
      >
        <ArrowImage
          src={arrowImage}
          alt=""
          width={336}
          height={390}
          sx={{
            width: { xs: 230, md: 336 },
            minWidth: { xs: 230, md: 336 },
            height: { xs: 267, md: 390 },
          }}
          ContainerProps={{ ...arrowImageTransition }}
        />
        <MotionStack
          width={1}
          maxWidth={646}
          variants={formStagger}
          initial="initial"
          whileInView={"animate"}
          viewport={{ once: true }}
          rowGap={4}
        >
          <MotionStack
            rowGap={{ xs: 2, md: 1 }}
            variants={formStaggerChildrenRight}
            textAlign={{ xs: "center", md: "left" }}
          >
            <Typography variant="h3">{header}</Typography>
            <Typography fontSize={"18px !important"}>{subHeader}</Typography>
            <Typography variant="caption" color={"#DADADA"}>
              {caption || ""}{" "}
              {href && <Link href={href}>Terms & Conditions</Link>}
            </Typography>
          </MotionStack>
          <MotionStack variants={formStagger}>
            {downloadData &&
              downloadData.map((item, idx) => (
                <MotionListItem
                  key={idx}
                  disablePadding
                  disableGutters
                  sx={{
                    borderBottom: "0.2px solid #EAEAEA30",
                  }}
                  secondaryAction={
                    <Link href={item.href}>
                      <BorderedIconButton
                        sx={{ ...iconButtonLargeSx, width: 40, height: 40 }}
                        size={"medium"}
                      >
                        <FileDownloadOutlined />
                      </BorderedIconButton>
                    </Link>
                  }
                  variants={formStaggerChildrenUp}
                >
                  <ListItemText
                    primary={item.title}
                    secondary={item.subTitle}
                    primaryTypographyProps={{
                      fontSize: "18px !important",
                    }}
                    secondaryTypographyProps={{
                      variant: "caption",
                      color: "#DADADA",
                      mt: 1,
                    }}
                    sx={{ my: 2 }}
                  />
                </MotionListItem>
              ))}
          </MotionStack>
        </MotionStack>
      </Stack>
    </SectionWrapper>
  );
};

export default NewsAndMediaPressKit;
